import { LocalStorageKey } from '../constants/localStorageKeys';
import { UtilitiesService } from '../services/utilitiesService';

export const signOut = () => {
	const utilitiesService = new UtilitiesService();
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.users });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.token });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.systemSettings });
	utilitiesService.removeLocalStorage({
		item: LocalStorageKey.loadAllCollection,
	});
	utilitiesService.removeLocalStorage({
		item: LocalStorageKey.investorsCollections,
	});
	utilitiesService.removeLocalStorage({
		item: LocalStorageKey.borrowersCollections,
	});
	utilitiesService.removeLocalStorage({
		item: LocalStorageKey.notificationType,
	});
	utilitiesService.removeLocalStorage({
		item: LocalStorageKey.registrationInfo,
	});
	utilitiesService.removeLocalStorage({
		item: LocalStorageKey.registrationData,
	});
	utilitiesService.removeLocalStorage({ item: 'guideStepCount' });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.nafathVerified });
	utilitiesService.removeLocalStorage({ item: 'sessionExpired' });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.userLoggedInFirstTime });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.tokenExpiring });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.isKSApopup });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.checkPointServey });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.myOrders });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.userContactNumber });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.userPersonalInfo });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.depositPopup });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.isTermsDone });
};
